import React, { useEffect, useState } from 'react';
import useCheckPermission from '../../utils/permissions/useCheckPermissions';
import MaterialTable, { MTableFilterRow } from 'material-table';
import UserDataService from '../../services/UserService';
import DepartmentDataService from '../../services/DepartmentService';
import LocationDataService from '../../services/LocationService';
import axios from 'axios';
import { API_URL } from '../../utils/setApiUrl.js';
import DeviceUsersService from '../../services/DeviceUsersService';
import TemplateService from '../../services/TemplateService';
import { Snackbar } from '@mui/material';
import Alert from '@material-ui/lab/Alert';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import PinIcon from '@mui/icons-material/Pin';
import ModalForm from './Modal';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CircularProgress from '@material-ui/core/CircularProgress';
import DoNotTouchIcon from '@mui/icons-material/DoNotTouch';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useTranslation } from 'react-i18next';

// import EditModalForm from './EditFiles/EditModal'

const useStyles = makeStyles(theme => ({
    button: {
        marginLeft: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(2),
    },
    grid: { marginLeft: theme.spacing(2) },
    toolbar: { marginLeft: theme.spacing(10) },
    absoluteContainer: {
        position: 'absolute',
        zIndex: 9,
        width: '45vw',
        [theme.breakpoints.down('md')]: {
            position: 'initial',
        },
    },
}));

function UsersTable() {
    const classes = useStyles();
    const { t } = useTranslation();

    // Get user role from localStorage as a simple string
    const [isAnalyzer, setIsAnalyzer] = useState(() => {
        const userRole = localStorage.getItem('level');
        return userRole === 'analyzer';
    });

    // ! Permissions Check
    const isSuper = useCheckPermission('super');
    const canRead = useCheckPermission('r');
    const canCreate = useCheckPermission('c');
    const canUpdate = useCheckPermission('u');
    const canDelete = useCheckPermission('d');

    const [users, setUser] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [usersPin, setUserPin] = useState([]);

    useEffect(() => {
        retrieveUsers();
        retrieveDepartments();
        retrieveLocations();
    }, []);

    const [loc] = React.useState(() => {
        const locData = localStorage.getItem('loc');
        return locData ? JSON.parse(locData).id : '';
    });
    const retrieveUsers = async () => {
        setIsLoading(true);
        const locData = JSON.parse(localStorage.getItem('loc'));

        try {
            let response;

            if (Array.isArray(locData)) {
                const joinedValues = locData.join(',');
                response = await UserDataService.getAll(joinedValues);
            } else if (locData.id === 'all') {
                response = await UserDataService.adminAll();
                client
                    .get(`/v1/templates/`)
                    .then(response => {
                        setTemplates(response.data);
                    })
                    .catch(e => {
                        setErrorMessages(['Cannot load user data']);
                        setIserror(true);
                    });
            }

            if (response) {
                setUser(response.data);
                setIsLoading(false);
                console.log(response.data);
            }
        } catch (e) {
            console.log(e);
            setIsLoading(false);
        }
    };

    // const retrieveUsers = () => {
    //     if (JSON.parse(localStorage.getItem('loc')).id >= 0) {
    //         UserDataService.getAll(loc)
    //             .then((response) => {
    //                 setUser(response.data);
    //             })
    //             .catch((e) => {
    //                 setErrorMessages(['Cannot load user data']);
    //                 setIserror(true);
    //             });
    //     } else if (JSON.parse(localStorage.getItem('loc')).id === 'all') {
    //         client
    //             .get(`/v1/templates/`)
    //             .then((response) => {
    //                 setTemplates(response.data);
    //             })
    //             .catch((e) => {
    //                 setErrorMessages(['Cannot load user data']);
    //                 setIserror(true);
    //             });
    //         UserDataService.adminAll()
    //             .then((response) => {
    //                 setUser(response.data);
    //             })
    //             .catch((e) => {
    //                 setErrorMessages(['Cannot load user data']);
    //                 setIserror(true);
    //             });
    //     }
    // };

    //for error handling
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Snackbars Start
    const [snackbars, setSnackbars] = useState([]);

    const handleCloseSnackbar = id => {
        setSnackbars(prevSnackbars =>
            prevSnackbars.filter(snackbar => snackbar.id !== id)
        );
    };

    const handleShowSnackbar = (message, severity) => {
        const id = new Date().getTime(); // Unique ID for each snackbar
        const newSnackbar = {
            id,
            message,
            severity,
            position: snackbars.length * 55,
        };

        setSnackbars(prevSnackbars => [...prevSnackbars, newSnackbar]);
    };
    //Snackbars End

    const client = axios.create({
        baseURL: API_URL,
    });

    const handleUserRemove = (removeUser, resolve) => {
        client
            .post(`/removeUserEverywhere`, {
                user: JSON.stringify(removeUser.sap),
            })
            .then(response => {
                if (response.status === 200) {
                    DeviceUsersService.remove(removeUser.sap).then(response => {
                        if (response.status === 200) {
                            handleShowSnackbar(
                                t('employees.removeSuccess'),
                                'success'
                            );
                        } else {
                            handleShowSnackbar(
                                t('employees.removeError'),
                                'error'
                            );
                        }
                    });
                    UserDataService.remove(removeUser.sap)
                        .then(res => {
                            const dataRemove = [...users];
                            const index = removeUser.tableData.id;
                            dataRemove.splice(index, 1);
                            setUser([...dataRemove]);
                            resolve();
                            retrieveUsers();
                            if (res.status === 200) {
                                handleShowSnackbar(
                                    t('employees.removeSuccessMessage'),
                                    'success'
                                );
                            } else {
                                handleShowSnackbar(
                                    t('employees.removeErrorMessage'),
                                    'error'
                                );
                            }
                        })
                        .catch(error => {
                            setErrorMessages([t('employees.removeError')]);
                            setIserror(true);
                        });
                    TemplateService.remove(removeUser.sap)
                        .then(res => {
                            resolve();
                            setIsLoading(false);
                            handleShowSnackbar(
                                t('employees.removeSuccessMessage2'),
                                'success'
                            );
                            retrieveUsers();
                        })
                        .catch(error => {
                            setErrorMessages([t('employees.removeError')]);
                            setIserror(true);
                        });
                } else {
                    handleShowSnackbar(t('employees.removeError'), 'error');
                }
            });
    };

    const handleUserFingersRemove = (sap, resolve) => {
        client
            .post(`/removeUserEverywhere`, {
                user: JSON.stringify(sap),
            })
            .then(response => {
                if (response.status === 200) {
                    DeviceUsersService.remove(sap).then(response => {
                        if (response.status === 200) {
                            handleShowSnackbar(
                                t('employees.removeSuccessMessage'),
                                'success'
                            );
                        } else {
                            handleShowSnackbar(
                                t('employees.removeErrorMessage'),
                                'error'
                            );
                        }
                    });
                    TemplateService.remove(sap)
                        .then(res => {
                            resolve();
                            setIsLoading(false);
                            handleShowSnackbar(
                                t('employees.removeSuccessMessage2'),
                                'success'
                            );
                            retrieveUsers();
                        })
                        .catch(error => {
                            setErrorMessages([t('employees.removeError')]);
                            setIserror(true);
                        });
                } else {
                    handleShowSnackbar(t('employees.removeError'), 'error');
                }
            });
    };

    //! Edit User Event Start
    const [submitted, setSubmitted] = useState(false);

    // const handleUserUpdate = (newUserData, resolve) => {
    // 	if (usersPin === newUserData) {
    // 		alert("Моля напишете друг пин")
    // 	} else {
    // 		UserDataService.update(newUserData)
    // 			.then(response => {
    // 				setSubmitted(true)
    // 				console.log(response.data)
    // 				resolve()
    // 			})
    // 			.catch(e => {
    // 				console.log(e)
    // 			})
    // 	}
    // }

    const [departmentsOptions, setDepartmentsOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [locations, setLocations] = useState([]);
    const [departmentsByLocation, setDepartmentsByLocation] = useState({});
    const [selectedLocation, setSelectedLocation] = useState(null);

    const retrieveLocations = () => {
        const locData = JSON.parse(localStorage.getItem('loc'));

        LocationDataService.getAll()
            .then(response => {
                let filteredLocations;

                if (locData && locData.id === 'all') {
                    // Show all locations
                    filteredLocations = response.data;
                } else if (Array.isArray(locData)) {
                    // loc_token stores location numbers, not internal ids
                    filteredLocations = response.data.filter(location =>
                        locData.includes(location.number)
                    );
                } else {
                    // If locData is invalid or not present, show no locations
                    filteredLocations = [];
                }

                // Transform locations into lookup format
                const locationsLookup = {};
                filteredLocations.forEach(location => {
                    // Use location name as both key and value for the lookup
                    locationsLookup[location.name] = location.name;
                });

                setLocations(filteredLocations);
                setLocationOptions(locationsLookup);
                console.log('Locations lookup:', locationsLookup);
            })
            .catch(e => {
                console.log(e);
            });
    };

    const retrieveDepartments = async () => {
        const locData = JSON.parse(localStorage.getItem('loc'));

        try {
            let response;

            if (Array.isArray(locData)) {
                const joinedValues = locData.join(',');
                response = await DepartmentDataService.getAll(joinedValues)
                    .then(response => {
                        console.log('Departments response:', response.data);

                        // Create a lookup object for all departments
                        const transformedDepartments = {};
                        response.data.forEach(department => {
                            // Use department name as both key and value for the lookup
                            transformedDepartments[department.name] =
                                department.name;
                        });

                        // Group departments by parent location
                        const deptsByLoc = {};
                        response.data.forEach(department => {
                            // Get the parent location name from ParentLocation
                            const parentLocationName = department.ParentLocation
                                ? department.ParentLocation.name
                                : null;

                            if (parentLocationName) {
                                // Initialize the object for this location if it doesn't exist
                                if (!deptsByLoc[parentLocationName]) {
                                    deptsByLoc[parentLocationName] = {};
                                }

                                // Add this department to its parent location's group
                                deptsByLoc[parentLocationName][
                                    department.name
                                ] = department.name;
                            }
                        });

                        console.log('Departments by location:', deptsByLoc);
                        setDepartmentsByLocation(deptsByLoc);
                        setDepartmentsOptions(transformedDepartments);
                    })
                    .catch(e => {
                        console.log('Error fetching departments:', e);
                        setErrorMessages(['Cannot load department data']);
                        setIserror(true);
                    });
            } else if (locData.id === 'all') {
                response = await DepartmentDataService.adminAll()
                    .then(response => {
                        console.log(
                            'Departments response (admin):',
                            response.data
                        );

                        // Create a lookup object for all departments
                        const transformedDepartments = {};
                        response.data.forEach(department => {
                            // Use department name as both key and value for the lookup
                            transformedDepartments[department.name] =
                                department.name;
                        });

                        // Group departments by parent location
                        const deptsByLoc = {};
                        response.data.forEach(department => {
                            // Get the parent location name from ParentLocation
                            const parentLocationName = department.ParentLocation
                                ? department.ParentLocation.name
                                : null;

                            if (parentLocationName) {
                                // Initialize the object for this location if it doesn't exist
                                if (!deptsByLoc[parentLocationName]) {
                                    deptsByLoc[parentLocationName] = {};
                                }

                                // Add this department to its parent location's group
                                deptsByLoc[parentLocationName][
                                    department.name
                                ] = department.name;
                            }
                        });

                        console.log('Departments by location:', deptsByLoc);
                        setDepartmentsByLocation(deptsByLoc);
                        setDepartmentsOptions(transformedDepartments);
                    })
                    .catch(e => {
                        console.log('Error fetching departments (admin):', e);
                        setErrorMessages(['Cannot load department data']);
                        setIserror(true);
                    });
            }
        } catch (e) {
            console.log('Error in retrieveDepartments:', e);
        }
    };
    // * End of retrieving Locations & Departments

    // * Users In Device Table
    const [deviceUsers, setDeviceUsers] = useState([]);

    useEffect(() => {
        retrieveDeviceUsers();
    }, []);

    const retrieveDeviceUsers = () => {
        if (JSON.parse(localStorage.getItem('loc')).id >= 0) {
            DeviceUsersService.getAll(loc)
                .then(response => {
                    setDeviceUsers(response.data);
                })
                .catch(e => {
                    setErrorMessages(['Cannot load devices']);
                    setIserror(true);
                });
        } else if (JSON.parse(localStorage.getItem('loc')).id === 'all') {
            DeviceUsersService.adminAll()
                .then(response => {
                    setDeviceUsers(response.data);
                })
                .catch(e => {
                    setErrorMessages(['Cannot load devices']);
                    setIserror(true);
                });
        }
    };
    // * Retrieve Users In Device End

    useEffect(() => {
        const filterCells = document.querySelectorAll('.MuiTableCell-filtered');

        const handleScroll = () => {
            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            const tableTop = document.querySelector('.MuiTable-root').offsetTop;

            if (scrollTop > tableTop) {
                filterCells.forEach(cell => {
                    cell.classList.add('sticky');
                });
            } else {
                filterCells.forEach(cell => {
                    cell.classList.remove('sticky');
                });
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleUserUpdate = async (newUserData, resolve) => {
        console.log('Updating user with data:', newUserData);

        // Keep loc_number in sync when location name changes
        if (newUserData.loc_name) {
            const selectedLocation = locations.find(
                location => location.name === newUserData.loc_name
            );
            if (selectedLocation) {
                newUserData.loc_number = selectedLocation.number;
                newUserData.loc_name = selectedLocation.name;
            }
        }

        // Check if the selected department belongs to the selected location
        const locationDepartments =
            departmentsByLocation[newUserData.loc_name] || {};
        if (
            newUserData.sub_loc_name &&
            !locationDepartments[newUserData.sub_loc_name]
        ) {
            newUserData.sub_loc_name = null;
        }

        try {
            // Check if PIN was changed and validate uniqueness
            if (newUserData.pin && newUserData.pin.trim() !== '') {
                // Find the original user data to compare PIN
                const originalUser = users.find(
                    user => user.sap === newUserData.sap
                );

                // Only check PIN uniqueness if the PIN was actually changed
                if (!originalUser || originalUser.pin !== newUserData.pin) {
                    // Validate PIN format (4 digits)
                    if (!/^\d{4}$/.test(newUserData.pin)) {
                        handleShowSnackbar(
                            t('employees.pinValidationError'),
                            'error'
                        );
                        resolve();
                        return;
                    }

                    // Check if PIN is unique
                    const pinCheckResponse = await UserDataService.checkPinUnique(
                        newUserData.pin
                    );

                    if (
                        !pinCheckResponse.data ||
                        !pinCheckResponse.data.unique
                    ) {
                        handleShowSnackbar(
                            t('employees.pinAlreadyUsedError'),
                            'error'
                        );
                        resolve();
                        return;
                    }
                }
            }

            // Proceed with user update if PIN validation passed
            const response = await UserDataService.update(
                newUserData.sap,
                newUserData
            );

            setSubmitted(true);
            console.log('Update response:', response.data);
            retrieveUsers();
            handleShowSnackbar(t('employees.updatedUserMessage'), 'success');
            resolve();
        } catch (e) {
            console.log('Error updating user:', e);
            setErrorMessages([t('employees.updatedUserErrorMessage')]);
            setIserror(true);
            handleShowSnackbar(t('employees.updatedUserErrorMessage'), 'error');
            resolve();
        }
    };

    const [generatingPin, setGeneratingPin] = useState(false);
    const [activePinGenerationUser, setActivePinGenerationUser] = useState(
        null
    );

    // Debug function to check button state - remove in production
    const checkButtonState = () => {
        console.log('Pin Generation State:', generatingPin);
        console.log('Active User:', activePinGenerationUser);
    };

    // Initialize state when table is rendered
    const initializeState = () => {
        console.log('Initializing state');
        setGeneratingPin(false);
        setActivePinGenerationUser(null);
    };

    // Call initialization on mount and after data load
    useEffect(() => {
        initializeState();
    }, []);

    // Call initialization when users data changes
    useEffect(() => {
        if (users.length > 0) {
            initializeState();
        }
    }, [users]);

    // Function to generate a random 4-digit PIN
    const generateRandomPin = () => {
        return Math.floor(1000 + Math.random() * 9000).toString();
    };

    // Function to generate and save a unique PIN for a user
    const generateAndSavePin = async rowData => {
        console.log('Starting PIN generation for user:', rowData.sap);

        if (generatingPin) {
            console.log('Already generating a PIN, ignoring request');
            return;
        }

        // Set global PIN generation state to active and track which user is generating
        setGeneratingPin(true);
        setActivePinGenerationUser(rowData.sap);

        // Show message that generation has started
        handleShowSnackbar(
            t('employees.createForm.generatingPin', {
                name: rowData.name,
            }),
            'info'
        );

        console.log('PIN generation state set:', true);

        let isUnique = false;
        let newPin = '';

        try {
            // Try up to 10 times to find a unique PIN
            for (let i = 0; i < 10; i++) {
                newPin = generateRandomPin();
                const response = await UserDataService.checkPinUnique(newPin);

                if (response.data && response.data.unique) {
                    isUnique = true;
                    break;
                }
            }

            if (isUnique) {
                // Show a message that we're updating the user
                handleShowSnackbar(
                    t('employees.createForm.pinGenerated', {
                        name: rowData.name,
                    }),
                    'info'
                );

                // Update the user with the new PIN
                const updatedUser = {
                    ...rowData,
                    pin: newPin,
                };

                // Call API to update the user in database
                await UserDataService.update(rowData.sap, updatedUser);

                // Show success message
                handleShowSnackbar(
                    t('employees.createForm.pinGeneratedSuccess', {
                        pin: newPin,
                    }),
                    'success'
                );

                // Refresh the table to show the new PIN
                retrieveUsers();
            } else {
                console.error(
                    'Could not generate a unique PIN after several attempts'
                );
                handleShowSnackbar(
                    t('employees.createForm.pinGeneratedError'),
                    'error'
                );
            }
        } catch (error) {
            console.error('Error generating unique PIN:', error);
            handleShowSnackbar(
                t('employees.createForm.pinGenerationFailed'),
                'error'
            );
        } finally {
            // Reset PIN generation state
            console.log('Resetting PIN generation state');
            setGeneratingPin(false);
            setActivePinGenerationUser(null);
            setTimeout(() => {
                console.log('PIN generation state after reset:', generatingPin);
            }, 100);
        }
    };

    return (
        <div>
            {snackbars
                .slice()
                .reverse()
                .map((snackbar, index) => (
                    <Snackbar
                        key={snackbar.id}
                        open={true}
                        autoHideDuration={5000}
                        onClose={() => handleCloseSnackbar(snackbar.id)}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        style={{ bottom: `${10 + index * 55}px` }}
                    >
                        <Alert
                            elevation={6}
                            variant="filled"
                            severity={snackbar.severity}
                            onClose={() => handleCloseSnackbar(snackbar.id)}
                        >
                            {snackbar.message}
                        </Alert>
                    </Snackbar>
                ))}
            {canCreate && <ModalForm buttonLabel="Добавяне" />}
            <MaterialTable
                title={t('employees.title')}
                columns={[
                    {
                        title: t('employees.employeeID'),
                        field: 'sap',
                        editable: false,
                    },
                    {
                        field: 'enrolled',
                        title: 'Enrolled',
                        editable: false,
                        render: rowData => {
                            return (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div style={{ flex: '0 0 50px' }}>
                                        {rowData.enrolled === 'YES' ? (
                                            <FingerprintIcon
                                                style={{ color: 'green' }}
                                            />
                                        ) : (
                                            <FingerprintIcon
                                                style={{ color: 'red' }}
                                            />
                                        )}
                                    </div>
                                </div>
                            );
                        },
                    },
                    { title: 'Id', field: 'id', hidden: true },
                    {
                        title: t('employees.employeeName'),
                        field: 'name',
                        defaultSort: 'asc',
                    },
                    // {
                    //     title: 'Магазин',
                    //     field: 'loc_name',
                    //     // lookup: locationOptions,
                    //     cellStyle: (e, rowData) => {
                    //         if (rowData.loc_name === 'null') {
                    //             return { backgroundColor: '#FFCCCC' };
                    //         }
                    //     },
                    // },
                    {
                        title: t('employees.location'),
                        field: 'loc_name',
                        lookup: locationOptions,
                        cellStyle: (e, rowData) => {
                            if (
                                rowData.loc_name === 'null' ||
                                !rowData.loc_name
                            ) {
                                return { backgroundColor: '#FFCCCC' };
                            }
                        },
                    },
                    {
                        title: t('employees.department'),
                        field: 'sub_loc_name',
                        lookup: departmentsOptions,
                        editComponent: props => {
                            // Get the current location from the row data
                            const currentLocation = props.rowData.loc_name;

                            // Get departments for the selected location
                            const availableDepartments =
                                departmentsByLocation[currentLocation] || {};

                            // Create an array of department options for Autocomplete
                            const departmentOptions = Object.entries(
                                availableDepartments
                            ).map(([key, value]) => ({
                                value: key,
                                label: value,
                            }));

                            return (
                                <Autocomplete
                                    options={departmentOptions}
                                    getOptionLabel={option => option.label}
                                    value={
                                        props.value
                                            ? departmentOptions.find(
                                                  option =>
                                                      option.value ===
                                                      props.value
                                              ) || null
                                            : null
                                    }
                                    onChange={(event, newValue) => {
                                        props.onChange(
                                            newValue ? newValue.value : null
                                        );
                                    }}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            size="small"
                                            fullWidth
                                            placeholder={t(
                                                'employees.chooseDepartment'
                                            )}
                                        />
                                    )}
                                    style={{ minWidth: 200 }}
                                />
                            );
                        },
                        cellStyle: (e, rowData) => {
                            if (
                                rowData.sub_loc_name === 'null' ||
                                !rowData.sub_loc_name
                            ) {
                                return { backgroundColor: '#FFCCCC' };
                            }
                        },
                    },

                    { title: t('employees.cardNumber'), field: 'card' },
                    {
                        title: t('employees.pin'),
                        field: 'pin',
                        render: rowData => <>{rowData.pin || ''}</>,
                        editComponent: props => (
                            <TextField
                                type="text"
                                value={props.value || ''}
                                onChange={e => props.onChange(e.target.value)}
                                inputProps={{
                                    maxLength: 4,
                                    pattern: '[0-9]*',
                                }}
                                placeholder={t(
                                    'employees.createForm.pinPlaceholder'
                                )}
                            />
                        ),
                    },
                    {
                        title: t('employees.workHoursContract'),
                        field: 'work_hours',
                        render: rowData =>
                            parseFloat(rowData.work_hours).toFixed(2),
                        editComponent: props => (
                            <TextField
                                type="number"
                                step="0.5"
                                value={props.value}
                                onChange={e =>
                                    props.onChange(parseFloat(e.target.value))
                                }
                                inputProps={{ step: 0.5 }}
                            />
                        ),
                    },
                ]}
                data={users}
                style={{
                    borderRadius: '0',
                    boxShadow: 'none',
                }}
                actions={[
                    {
                        icon: 'refresh',
                        tooltip: 'Refresh',
                        isFreeAction: true,
                        onClick: retrieveUsers,
                    },
                    ...(!isAnalyzer
                        ? [
                              {
                                  icon: DoNotTouchIcon,
                                  tooltip: t('employees.removeFingerprints'),
                                  onClick: (event, rowData) => {
                                      const confirmed = window.confirm(
                                          t(
                                              'employees.removeFingerprintsConfirmation'
                                          )
                                      );
                                      if (confirmed) {
                                          new Promise(resolve => {
                                              setIsLoading(true);
                                              handleShowSnackbar(
                                                  t(
                                                      'employees.removingFingerprints'
                                                  ),
                                                  'info'
                                              );
                                              handleUserFingersRemove(
                                                  rowData.sap,
                                                  resolve
                                              );
                                              retrieveUsers();
                                          });
                                      }
                                  },
                              },
                              {
                                  icon: rowData => {
                                      // Show loading spinner for active PIN generation user
                                      if (
                                          rowData.sap ===
                                              activePinGenerationUser &&
                                          generatingPin
                                      ) {
                                          return (
                                              <CircularProgress
                                                  size={24}
                                                  style={{ color: '#1976d2' }}
                                              />
                                          );
                                      }

                                      // Show a normal PIN icon with proper styling based on availability
                                      return (
                                          <PinIcon
                                              style={{
                                                  opacity: generatingPin
                                                      ? 0.5
                                                      : 1, // Gray out all PIN icons when generating
                                                  color: generatingPin
                                                      ? '#9e9e9e'
                                                      : '#000', // Change color when disabled
                                              }}
                                              // Add direct title attribute as a fallback
                                              title={t(
                                                  'employees.createForm.generatePin'
                                              )}
                                          />
                                      );
                                  },
                                  tooltip: t(
                                      'employees.createForm.generatePin'
                                  ), // Static tooltip as default
                                  tooltipFn: rowData => {
                                      // Dynamic tooltip function
                                      // For debugging
                                      console.log(
                                          'Tooltip called for PIN button:',
                                          rowData.sap
                                      );

                                      if (generatingPin) {
                                          // During PIN generation
                                          try {
                                              const tooltipText =
                                                  rowData.sap ===
                                                  activePinGenerationUser
                                                      ? t(
                                                            'employees.createForm.generatePin'
                                                        )
                                                      : t(
                                                            'employees.createForm.generatingPin2Message'
                                                        );
                                              return tooltipText;
                                          } catch (e) {
                                              console.error(
                                                  'Error in translation:',
                                                  e
                                              );
                                              return rowData.sap ===
                                                  activePinGenerationUser
                                                  ? t(
                                                        'employees.createForm.generatePin'
                                                    )
                                                  : t(
                                                        'employees.createForm.generatingPin2Message'
                                                    );
                                          }
                                      }

                                      // Default tooltip - with fallback
                                      try {
                                          const translatedTooltip = t(
                                              'employees.createForm.generatePin'
                                          );

                                          // If translation is empty or undefined, use direct string
                                          return translatedTooltip;
                                      } catch (e) {
                                          console.error(
                                              'Error in default tooltip translation:',
                                              e
                                          );
                                          return t(
                                              'employees.createForm.generatePin'
                                          ); // Direct fallback
                                      }
                                  },
                                  onClick: (event, rowData) => {
                                      // Only allow generating if not already in progress
                                      if (!generatingPin) {
                                          generateAndSavePin(rowData);
                                      } else {
                                          // Show a message that PIN generation is in progress
                                          handleShowSnackbar(
                                              t(
                                                  'employees.createForm.pinGenerationInProgress'
                                              ),
                                              'info'
                                          );
                                      }
                                  },
                                  // Don't use the disabled property as it might be causing issues
                                  disabled: false,
                              },
                          ]
                        : []),
                ]}
                isLoading={isLoading}
                options={{
                    loadingType: 'linear',
                    pageSize: 50,
                    maxBodyHeight: '68vh',
                    showTitle: true,
                    sorting: true,
                    actionsColumnIndex: -1,
                    exportButton: !isAnalyzer
                        ? { csv: true, pdf: false }
                        : false,
                    filtering: true,
                    pageSizeOptions: [5, 10, 20, 50, 100, 500],
                }}
                components={{
                    FilterRow: props => <MTableFilterRow {...props} />,
                }}
                editable={{
                    ...(canUpdate
                        ? {
                              onRowUpdate: newUserData =>
                                  new Promise(resolve => {
                                      handleUserUpdate(newUserData, resolve);
                                      //   setTimeout(() => {
                                      //       window.location.reload(1);
                                      //   }, 1500); // 1.5 seconds delay
                                  }),
                          }
                        : {}),
                    ...(canDelete
                        ? {
                              onRowDelete: removeUser =>
                                  new Promise(resolve => {
                                      handleUserRemove(removeUser, resolve);
                                      //   setTimeout(() => {
                                      //       window.location.reload(1);
                                      //   }, 1500); // 1.5 seconds delay
                                  }),
                          }
                        : {}),
                }}
                localization={{
                    pagination: {
                        labelDisplayedRows:
                            '{from}-{to} ' +
                            t('reports.common.of') +
                            ' {count}',
                        labelRowsPerPage: t('reports.common.rowsPerPage'),
                        labelRowsSelect: t('reports.common.rowsSelect'),
                    },
                    header: {
                        actions: t('reports.common.actions'),
                    },
                    body: {
                        emptyDataSourceMessage: t(
                            'reports.common.emptyDataSourceMessage'
                        ),
                        editTooltip: t('reports.common.edit'),
                        deleteTooltip: t('reports.common.delete'),
                        filterRow: {
                            filterTooltip: t('reports.common.filter'),
                        },
                        editRow: {
                            deleteText: t('employees.removeConfirmation'),
                            cancelTooltip: t('reports.common.cancel'),
                            saveTooltip: t('reports.common.save'),
                        },
                    },
                    toolbar: {
                        exportTitle: t('reports.common.export'),
                        exportName: t('reports.common.exportCSV'),
                        searchTooltip: t('reports.common.search'),
                        searchPlaceholder: t(
                            'reports.common.searchPlaceholder'
                        ),
                    },
                }}
                onLoad={() => {
                    setGeneratingPin(false);
                    setActivePinGenerationUser(null);
                }}
            />
        </div>
    );
}

export default UsersTable;
